/*
 * Whether this deployment can store and hand out attachment files (S47): the
 * server's /api/config says, from ATTACHMENTS_BLOB_ENDPOINT. Only an explicit
 * false counts as off - while the configuration is still loading, or from a
 * server that predates the flag, the controls stay usable and the server's own
 * 503 explains itself if it must.
 */

import { useClientConfig } from '../auth/AuthProvider.js';

export function useAttachmentsEnabled(): boolean {
  return useClientConfig()?.features.attachments !== false;
}
